import classNames from 'classnames';
import * as React from 'react';
const Checkbox = (props) => {
    const { checked, className, inputRef, onChange = () => void 0, optimisticUpdate, style, unlabelled, ...rest } = props;
    const Wrapper = unlabelled
        ? (props) => React.createElement("div", { ...props })
        : (props) => React.createElement("label", { ...props });
    return (React.createElement(Wrapper, { className: "ixu-checkbox", style: style },
        React.createElement("input", { ...rest, checked: !optimisticUpdate ? checked : undefined, className: classNames(className, 'ixu-checkbox__native'), defaultChecked: optimisticUpdate ? checked : undefined, onChange: e => onChange(e.target.checked), ref: inputRef, type: "checkbox" }),
        React.createElement("div", { className: "ixu-checkbox__faux" })));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map